import { store } from 'src/common/redux/configure-store';
import { EpsData, PaymentMessage } from 'src/devices/payment/dtos/eps-data';
import { completeEwicRxDto } from 'src/devices/payment/pinpad-operations';
import { CartTenders } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { handleEwicReceipts } from './handle-ewic-receipts';
import { getCartTenders } from './services/get-cart-tenders';

export const buildRxDto = async (
  paymentMsg: PaymentMessage,
  epsData: EpsData,
): Promise<completeEwicRxDto> => {
  const { requiresGetTenderFromCart } = getCurrentXLRConfig();
  const paymentTranId = epsData.paymentTranID;
  let tenderedAmount: number;
  let dueAmount: number;
  let ewicData: string;

  if (requiresGetTenderFromCart) {
    const ewicTender = await getCartTenders(
      store.getState().transaction.transactionId,
    ).then((response: CartTenders) =>
      response.pageContent.find(tender => !!tender.wic && tender.status === 'preTender'),
    );
    const wicData = ewicTender?.wic;
    await handleEwicReceipts(ewicTender?.amount ?? 0, wicData);

    tenderedAmount = ewicTender?.amount || 0;
    dueAmount = ewicTender?.amount || 0;
    ewicData = `${wicData?.rawPSRecords}`;
  } else {
    tenderedAmount = store.getState().tendering.ewicEpsUtilizedAmountTotal;
    dueAmount = store.getState().tendering.ewicEpsUtilizedAmountTotal;
    ewicData = paymentMsg.ewicData ?? '';
  }
  return {
    paymentTranId: paymentTranId,
    tenderedAmount: tenderedAmount,
    dueAmount: dueAmount,
    ewicData: ewicData,
  };
};
